import styled from 'styled-components';

/* ─── Cover & Profile Header ─── */

export const CoverArea = styled.div`
  width: 100%;
  height: 250px;
  background: ${({ theme }) => theme.colors.bgSecondary};
  position: relative;
  border-radius: ${({ theme }) => theme.metrics.radius.large};
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ProfilePicture = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.border};
  border: 4px solid ${({ theme }) => theme.colors.bgColor};
  position: absolute;
  bottom: -60px;
  left: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-shadow: 0 4px 12px ${({ theme }) => theme.colors.shadow};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .anticon {
    font-size: 48px;
    color: ${({ theme }) => theme.colors.text.dark.little};
  }
`;

export const HeaderInfo = styled.div`
  margin-top: 72px;
  padding: 0 8px;
`;

export const SellerName = styled.h1`
  font-family: ${({ theme }) => theme.typography.heading};
  font-size: ${({ theme }) => theme.typography.sizes.xxl};
  color: ${({ theme }) => theme.colors.text.dark.very};
  margin: 0 0 8px 0;
`;

export const SellerDescription = styled.p`
  font-size: ${({ theme }) => theme.typography.sizes.md};
  color: ${({ theme }) => theme.colors.text.dark.medium};
  line-height: 1.6;
  margin: 0 0 16px 0;
  max-width: 700px;
`;

export const MetaRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 12px;
`;

export const MetaItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  color: ${({ theme }) => theme.colors.text.dark.medium};

  .anticon {
    color: ${({ theme }) => theme.colors.text.dark.little};
  }
`;

export const HeaderActions = styled.div`
  margin-top: 16px;
`;

/* ─── Featured Items ─── */

export const FeaturedRow = styled.div`
  display: flex;
  gap: 20px;
  overflow-x: auto;
  padding-bottom: 8px;

  & > * {
    min-width: 220px;
    max-width: 220px;
    flex-shrink: 0;
  }

  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.border};
    border-radius: 3px;
  }
`;

/* ─── Full Inventory ─── */

export const InventoryHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
`;

export const BooksGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;

  @media (max-width: 992px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

/* ─── Page Sections ─── */

export const Section = styled.section`
  margin-top: 48px;
`;

export const PageWrapper = styled.div`
  padding-bottom: 40px;
`;
